
class SubscriptionService {
    constructor() {
        if (this.constructor === SubscriptionService) {
            throw new TypeError("Abstract class 'SubscriptionService' cannot be instantiated directly.");
        }

        if (this.getTarget === undefined) {
            throw new TypeError("Class derived from 'SubscriptionService' does not implement required method 'getTarget'");
        }

        if (this.getTargetBatch === undefined) {
            throw new TypeError("Class derived from 'SubscriptionService' does not implement required method 'getTargetBatch'");
        }

        if (this.addSubscription === undefined) {
            throw new TypeError("Class derived from 'SubscriptionService' does not implement required method 'addSubscription'");
        }

        if (this.removeSubscription === undefined) {
            throw new TypeError("Class derived from 'SubscriptionService' does not implement required method 'removeSubscription'");
        }
    }

    getTarget(subTargetId) {
        throw new TypeError(`Cannot call abstract method 'getTarget' in 'SubscriptionService' with ${subTargetId}`);
    }

    getTargetBatch(subTargetIds) {
        throw new TypeError(`Cannot call abstract method 'getTargetBatch' in 'SubscriptionService' with ${subTargetIds}`);
    }

    addSubscription(recipientId, subTargetId) {
        throw new TypeError(`Cannot call abstract method 'addSubscription' in 'SubscriptionService' with ${subTargetId}`);
    }

    removeSubscription(recipientId, subTargetId) {
        throw new TypeError(`Cannot call abstract method 'removeSubscription' in 'SubscriptionService' with ${subTargetId}`);
    }
}

export default SubscriptionService;



//////////////////
// WEBPACK FOOTER
// ./src/services/subscription-data-services/SubscriptionService.js
// module id = 3M+R
// module chunks = 1